export default "__VITE_ASSET__Dt9yLGq9__"